// Shipping size controls for staff (owner + advisor, 2026-11-02 — docs/PRICING_PLAN_2026-11-02.md §1.4):
//   - the size minimums per class (market_size_minimums): a variant ships on the LARGEST
//     of the seller's size, Gemini's and its class minimum — adjusted after real orders are weighed;
//   - one product's own size (market_product_size_override), with a note — e.g. a
//     roll-packed mattress; it IS the size (it replaces seller, Gemini and minimum);
//   - the review list: a seller weight under half of Gemini's estimate (a placeholder weight?).
// Writes go through admin RPCs (audited); the tables are admin-readable only.
import { marketDb, marketRpc } from './marketDb';

export async function listMinimums() {
  const { data, error } = await marketDb.from('market_size_minimums').select('*').order('sort');
  return error ? { ok: false, error: error.message } : { ok: true, data: data || [] };
}

export const setMinimum = (code, kg, m3) => marketRpc('admin_market_size_minimum_set', { p_code: code, p_min_kg: kg, p_min_m3: m3 });

export async function listOverrides() {
  const { data, error } = await marketDb.from('market_product_size_override').select('*').order('set_at', { ascending: false });
  if (error) return { ok: false, error: error.message };
  const ids = (data || []).map((r) => r.product_id);
  const { data: ps } = ids.length ? await marketDb.from('market_products').select('id, title_ar, title_en').in('id', ids) : { data: [] };
  const byId = Object.fromEntries((ps || []).map((p) => [p.id, p]));
  return { ok: true, data: (data || []).map((r) => ({ ...r, product: byId[r.product_id] || null })) };
}

/** Set one product's size (kg and/or m³, a note of 5+ characters); both empty removes it. */
export const setOverride = (productId, kg, m3, note) =>
  marketRpc('admin_market_size_override_set', { p_product_id: productId, p_min_kg: kg, p_min_m3: m3, p_note: note });

export const weightReview = (offset = 0, limit = 50) => marketRpc('admin_market_weight_review', { p_limit: limit, p_offset: offset });

/** A number field from a text box: '' → null, else a positive number or NaN (refused). */
export function parseSize(t) {
  const s = String(t ?? '').trim();
  if (s === '') return null;
  const n = Number(s);
  return Number.isFinite(n) && n > 0 ? n : NaN;
}

/** The product id from a pasted store link or a bare uuid; null when there is none. */
export function productIdFrom(text) {
  const m = String(text || '').match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i);
  return m ? m[0].toLowerCase() : null;
}
